import React from 'react';
import MainLayout from './layout/MainLayout';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { appName } from '../constants/const';

const PublicRoute = ({ component: Component, layout: Layout = MainLayout, title, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Helmet>
            <title>{title ? title + ' | ' + appName : appName}</title>
          </Helmet>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default PublicRoute;
